import dynamic from 'next/dynamic';

const FuelHero = dynamic(() => import('@components/FuelHero'));
const GrillHero = dynamic(() => import('@components/GrillHero'));
const TierTwoHero = dynamic(() => import('@repo/ui/src/components/TierTwoHero'));
const TraegerTVPlaylist = dynamic(() => import('@components/TraegerTvPlaylist'));
const CalloutGrid = dynamic(() => import('@repo/ui/src/components/CalloutGrid'));
const Administrative = dynamic(() => import('@views/AdminDetail'));
const Navbar = dynamic(() => import('@components/Navbar'));
const Navigation = dynamic(() => import('@components/Navigation'));
const Footer = dynamic(() => import('@components/Footer'));
const CalloutGridCard = dynamic(() => import('@repo/ui/src/components/CalloutGridCard'));
const GeneralCarousel = dynamic(() => import('@components/carousels/GeneralCarousel'));
const GeneralNestedSlot = dynamic(() => import('@components/GeneralNestedSlot'));
const GeneralBody = dynamic(() => import('@components/GeneralBody'));
const Page = dynamic(() => import('../views/Page'));
const VerticalCarousel = dynamic(() => import('@components/VerticalCarousel'));
const ProductAccordion = dynamic(() => import('@components/Product/Accordion'));
const GrillCapacityAndSpecs = dynamic(() => import('@components/GrillCapacityAndSpecs'));
const ScrollSequence = dynamic(() => import('@components/ScrollSequence'));
const StickyNavWithLinks = dynamic(() => import('@repo/ui/src/components/StickyNavWithLinks'));
const TextContentColumns = dynamic(() => import('@repo/ui/src/components/TextContentColumns'));
const CalloutSlider = dynamic(() => import('@repo/ui/src/components/CalloutSlider'));
const SeriesTitleAndText = dynamic(() => import('@repo/ui/src/components/SeriesTitleAndText'));
const ImageMask = dynamic(() => import('@components/ImageMask'));
const SeriesHero = dynamic(() => import('@repo/ui/src/components/SeriesHero'));
const FullWidthAssetCarousel = dynamic(
  () => import('@repo/ui/src/components/Carousels/full-width-asset-carousel'),
);
const ErrorBody = dynamic(() => import('@components/404Body'));
const Banner = dynamic(() => import('@components/Banner'));
const GeneralHalfSplit = dynamic(() => import('@repo/ui/src/components/GeneralHalfSplit'));
const SingleColumnText = dynamic(() => import('@components/shared/single-column-text'));
const FullWidthAsset = dynamic(() => import('@repo/ui/src/components/FullWidthAsset'));
const ThreeCardStack = dynamic(() => import('@repo/ui/src/components/ThreeCardStack'));
const EmailCapture = dynamic(() => import('@repo/ui/src/components/MarketingCapture'));
const ProductComparison = dynamic(() => import('@components/ProductComparison'));
const PageAnchor = dynamic(() => import('@repo/ui/src/components/PageAnchor'));
const CustomizeGrid = dynamic(() => import('@repo/ui/components/CustomizeGrid'));
const PDP = dynamic(() => import('@views/ProductDetailPage'));
const ForgotPassword = dynamic(() => import('@views/ForgotPassword'));
const LogoCarousel = dynamic(() => import('@components/carousels/LogoCarousel'));
const AllGrillsHero = dynamic(() => import('@components/AllGrillsHero'));
const Article = dynamic(() => import('@repo/ui/src/components/Article'));
const AccountDashboard = dynamic(() => import('@views/Account'));
const Author = dynamic(() => import('@views/Author'));
const BioHeaderCard = dynamic(() => import('@components/BioHeaderCard'));
const CareersJobPostings = dynamic(() => import('@components/CareersJobPostings'));
const Cart = dynamic(() => import('@components/Cart'));
const CascadingCards = dynamic(() => import('@repo/ui/src/components/CascadingCards'));
const CategoryGrid = dynamic(() => import('@components/CategoryGrid'));
const CategorySlider = dynamic(() => import('@components/CategorySlider'));
const DealerLocator = dynamic(() => import('@repo/ui/src/components/DealerLocator'));
const FeatureCarousel = dynamic(() => import('@repo/ui/src/components/FeatureCarousel'));
const FeaturedVideo = dynamic(() => import('@components/FeaturedVideo'));
const FixedBackgroundContainer = dynamic(() => import('@components/FixedBackgroundContainer'));
const FlexContainer = dynamic(() => import('@repo/ui/src/components/FlexContainer'));
const FooterNavCards = dynamic(() => import('@components/NavCards'));
const GiftCardDetail = dynamic(() => import('@components/GiftCardDetail'));
const GrillCapacityAndMeasurement = dynamic(
  () => import('@components/GrillCapacityAndMeasurement'),
);
const GrillFeatureComparison = dynamic(() => import('@components/SeriesGrillFeatureComparison'));
const GrillRecommendationResult = dynamic(() => import('@components/GrillRecommendationResult'));
const HalfSplitCarousel = dynamic(() => import('@components/carousels/HalfSplitCarousel'));
const HighlightVideoReference = dynamic(() => import('@components/HighlightVideoReference'));
const HomeHero = dynamic(() => import('@repo/ui/src/components/HomeHero'));
const JsonFormBody = dynamic(() => import('@components/forms/ProductRegistration'));
const LearnCategoryBody = dynamic(() => import('@views/LearnCategoryBody'));
const LifestyleBanner = dynamic(() => import('@components/LifestyleBanner'));
const MiniContentCarousel = dynamic(
  () => import('@components/carousels/mini-content-carousel/mini-content-carousel'),
);
const OrderTracking = dynamic(() => import('@components/OrderTrackingForm'));
const OrderConfirmation = dynamic(() => import('@views/OrderDetail/OrderConfirmation'));
const OverviewBody = dynamic(() => import('@views/LearnOverview'));
const PhotoGallery = dynamic(() => import('@components/PhotoGallery'));
const PhotoNavCards = dynamic(() => import('@components/NavCards'));
const ProductBundlePage = dynamic(() => import('@views/ProductBundlePage'));
const ProductFeatures = dynamic(() => import('@components/Product/_ProductFeatures'));
const ProductGrid = dynamic(() => import('@components/Product/Grid'));
const PromoBanner = dynamic(() => import('@components/shared/PromoBanner/promo-banner'));
const QuoteCarousel = dynamic(() => import('@repo/ui/src/components/QuoteCarousel'));
const RecipeCarousel = dynamic(() => import('@components/RecipeCarousel'));
const RecipeCategoryBody = dynamic(() => import('@views/RecipeCategory'));
const RecipeDetailBody = dynamic(() => import('@views/RecipeDetailPage'));
const RecommendedProducts = dynamic(() => import('@components/zr/shared/recommended-products'));
const RelatedProductGrid = dynamic(() => import('@components/RelatedProductGrid'));
const ResetPassword = dynamic(() => import('@views/ResetPassword'));
const SearchResultsBody = dynamic(() => import('@views/SearchResultsBody'));
const ShopBy = dynamic(() => import('@components/ShopBy'));
const SideBySide = dynamic(() => import('@repo/ui/src/components/SideBySide'));
const SideModalInstructions = dynamic(
  () => import('../components/recipe/recipe-detail/side-modal-instructions'),
);
const SplitBackground = dynamic(() => import('../components/SplitBackground'));
const SplitToutContent = dynamic(
  () => import('@repo/ui/src/components/ToutContent/_splitToutContent'),
);
const ToutContentWithMarkdown = dynamic(
  () => import('@repo/ui/src/components/ToutContent/_toutContentWithMarkdown'),
);
const TitledSplitToutContent = dynamic(
  () => import('@repo/ui/src/components/ToutContent/_titledSplitToutContent'),
);
const SpotlightCarousel = dynamic(() => import('@components/carousels/SpotlightCarousel'));
const Story = dynamic(() => import('../components/Story'));
const ThreeColumnContent = dynamic(() => import('../components/shared/three-column-content'));
const TwoThirdsText = dynamic(() => import('../components/shared/two-thirds-text'));
const FaqAccordion = dynamic(() => import('@repo/ui/src/components/FaqAccordion'));
const TraegerTVCategoryBody = dynamic(() => import('../views/TraegerTvCategoryBody'));
const TwoThirdsGeneralContent = dynamic(
  () => import('../components/shared/two-thirds-general-content'),
);
const WoodPelletFlavors = dynamic(() => import('../components/WoodPelletFlavors'));
const VideoFadeHero = dynamic(() => import('../components/VideoFadeHero'));
// const RecommendationsCarousel = dynamic(() => import('@components/Recommendations/_Carousel'));
const ImageSection = dynamic(() => import('@components/ImageSection'));
const ChipBar = dynamic(() => import('@repo/ui/src/components/ChipBar'));
const CountdownComponent = dynamic(() => import('@components/CountdownComponent'));

export const appComponentDirectory = {
  'https://traegergrills.com/data/slot/navbar.json': Navbar,
  'https://traeger.com/v2/data/slot/navigation.json': Navigation,
  'https://traegergrills.com/data/slot/footer.json': Footer,
  'https://traegergrills.com/data/nestedSlot/generalBody.json': GeneralBody,
  'https://traegergrills.com/data/contentTypes/learn.json': Administrative,
  'https://traegergrills.com/data/contentTypes/administrative.json': Administrative,
  'https://traegergrills.com/data/contentTypes/fuelHero.json': FuelHero,
  'https://traegergrills.com/data/contentTypes/calloutGrid.json': CalloutGrid,
  'https://traegergrills.com/data/contentTypes/grillHero.json': GrillHero,
  'https://traegergrills.com/data/contentTypes/generalHeroBannerWithSearch.json': TierTwoHero,
  'https://traegergrills.com/data/contentTypes/generalHeroBannerWithButton.json': TierTwoHero,
  'https://traeger.com/v2/tierTwoHero.json': TierTwoHero,
  'https://traegergrills.com/data/contentTypes/generalHeroBannerWithLinks.json': TierTwoHero,
  'https://traegergrills.com/data/contentTypes/generalHeroBannerWithText.json': TierTwoHero,
  'https://traegergrills.com/data/contentTypes/generalHeroBannerWithLogo.json': TierTwoHero,
  'https://traegergrills.com/data/contentTypes/traegerTVPlaylist.json': TraegerTVPlaylist,
  'https://traeger.com/v2/orderDetail.json': OrderConfirmation,
  'https://traegergrills.com/data/contentTypes/orderTracking.json': OrderTracking,
  'https://traegergrills.com/data/contentTypes/calloutGridCard.json': CalloutGridCard,
  'https://traegergrills.com/data/contentTypes/generalReferenceCarousel.json': GeneralCarousel,
  'https://traegergrills.com/data/contentTypes/recommendedAccessories.json': GeneralCarousel,
  'https://traegergrills.com/data/nestedSlot/general.json': GeneralNestedSlot,
  'https://traegergrills.com/data/slot/indexBody.json': GeneralNestedSlot,
  'https://traeger.com/v2/view/page.json': Page,
  'https://traegergrills.com/data/contentTypes/verticalCarousel.json': VerticalCarousel,
  'https://traeger.com/v2/productFeatures.json': ProductAccordion,
  'https://traeger.com/v2/component/tabbedFeatureComparison.json': GrillCapacityAndSpecs,
  'https://traegergrills.com/data/contentTypes/grillCapacityAndSpecs.json': GrillCapacityAndSpecs,
  'https://traeger.com/v2/component/scrollSequence.json': ScrollSequence,
  'https://traegergrills.com/data/contentTypes/stickyNavWithLinks.json': StickyNavWithLinks,
  'https://traegergrills.com/data/contentTypes/textContentColumns.json': TextContentColumns,
  'https://traegergrills.com/data/contentTypes/titledContentMultipleColumns.json':
    TextContentColumns,
  'https://traegergrills.com/data/contentTypes/calloutSlider.json': CalloutSlider,
  'https://traegergrills.com/data/contentTypes/seriesTitleAndText.json': SeriesTitleAndText,
  'https://traeger.com/v2/component/imageMask.json': ImageMask,
  'https://traegergrills.com/data/contentTypes/seriesHero.json': SeriesHero,
  'https://traegergrills.com/data/contentTypes/fullWidthAssetCarousel.json': FullWidthAssetCarousel,
  'https://traegergrills.com/data/contentTypes/banner.json': Banner,
  'https://traegergrills.com/data/contentTypes/generalHalfSplitContent.json': GeneralHalfSplit,
  'https://traegergrills.com/data/contentTypes/singleColumnText.json': SingleColumnText,
  'https://traegergrills.com/data/contentTypes/fullWidthAsset.json': FullWidthAsset,
  'https://traeger.com/v2/threeCardStack.json': ThreeCardStack,
  'https://traeger.com/v2/emailCapture.json': EmailCapture,
  'https://traeger.com/v2/view/productComparison.json': ProductComparison,
  'https://traegergrills.com/data/contentTypes/pageAnchor.json': PageAnchor,
  'https://traeger.com/v2/customizeGrid.json': CustomizeGrid,
  'https://traegergrills.com/data/contentTypes/product.json': PDP,
  'https://traegergrills.com/data/contentTypes/userForgotPassword.json': ForgotPassword,
  'https://traegergrills.com/data/contentTypes/logoCarousel.json': LogoCarousel,
  'https://traegergrills.com/data/contentTypes/deliveryAndAssembly.json': LogoCarousel,
  'https://traegergrills.com/data/contentTypes/userAuth.json': AccountDashboard,
  'https://traegergrills.com/data/contentTypes/allGrillsHero.json': AllGrillsHero,
  'https://traegergrills.com/data/contentTypes/article.json': Article,
  'https://traegergrills.com/v2/accountDashboard.json': AccountDashboard,
  'https://traegergrills.com/data/contentTypes/author.json': Author,
  'https://traegergrills.com/data/contentTypes/bioHeaderCard.json': BioHeaderCard,
  'https://traegergrills.com/data/contentTypes/careersJobPostings.json': CareersJobPostings,
  'https://traegergrills.com/data/contentTypes/basket.json': Cart,
  'https://traegergrills.com/data/contentTypes/cascadingCards.json': CascadingCards,
  'https://traegergrills.com/data/contentTypes/categoryGrid.json': CategoryGrid,
  'https://traegergrills.com/data/contentTypes/categorySlider.json': CategorySlider,
  'https://traegergrills.com/data/contentTypes/dealerLocator.json': DealerLocator,
  'https://traegergrills.com/data/contentTypes/featureCarousel.json': FeatureCarousel,
  'https://traegergrills.com/data/contentTypes/featuredVideo.json': FeaturedVideo,
  'https://traegergrills.com/data/contentTypes/fixedBackgroundContainer.json':
    FixedBackgroundContainer,
  'https://traeger.com/v2/flexContainer.json': FlexContainer,
  'https://traegergrills.com/data/contentTypes/footerNavCards.json': FooterNavCards,
  'https://traegergrills.com/data/contentTypes/giftCardPage.json': GiftCardDetail,
  'https://traegergrills.com/data/contentTypes/grillCapacityAndMeasurement.json':
    GrillCapacityAndMeasurement,
  'https://traegergrills.com/data/contentTypes/grillFeatureComparison.json': GrillFeatureComparison,
  'https://traegergrills.com/data/contentTypes/grillRecommendationResult.json':
    GrillRecommendationResult,
  'https://traegergrills.com/data/contentTypes/halfSplitContentCarousel.json': HalfSplitCarousel,
  'https://traegergrills.com/data/contentTypes/highlightVideoReference.json':
    HighlightVideoReference,
  'https://traegergrills.com/data/contentTypes/homeHero.json': HomeHero,
  'https://traegergrills.com/data/contentTypes/form.json': JsonFormBody,
  'https://traegergrills.com/data/slot/learnCategoryBody.json': LearnCategoryBody,
  'https://traegergrills.com/data/contentTypes/lifestyleBanner.json': LifestyleBanner,
  'https://traegergrills.com/data/contentTypes/miniContentCarousel.json': MiniContentCarousel,
  'https://traegergrills.com/data/slot/learnOverviewBody.json': OverviewBody,
  'https://traegergrills.com/data/slot/productOverviewBody.json': OverviewBody,
  'https://traegergrills.com/data/slot/recipeOverviewBody.json': OverviewBody,
  'https://traegergrills.com/data/contentTypes/photoGallery.json': PhotoGallery,
  'https://traegergrills.com/data/contentTypes/photoNavCards.json': PhotoNavCards,
  'https://traegergrills.com/data/contentTypes/productBundles.json': ProductBundlePage,
  'https://traegergrills.com/data/contentTypes/productFeatures.json': ProductFeatures,
  'https://traegergrills.com/data/contentTypes/productGrid.json': ProductGrid,
  'https://traegergrills.com/data/contentTypes/promoBanner.json': PromoBanner,
  'https://traegergrills.com/data/contentTypes/quoteCarousel.json': QuoteCarousel,
  'https://traegergrills.com/data/contentTypes/recipeCarousel.json': RecipeCarousel,
  'https://traegergrills.com/data/slot/recipeCategoryBody.json': RecipeCategoryBody,
  'https://traegergrills.com/data/contentTypes/recipe.json': RecipeDetailBody,
  'https://traegergrills.com/data/contentTypes/recommendedProducts.json': RecommendedProducts,
  'https://traegergrills.com/data/contentTypes/relatedProductGrid.json': RelatedProductGrid,
  'https://traegergrills.com/data/contentTypes/userResetPassword.json': ResetPassword,
  'https://traegergrills.com/data/slot/searchResultsBody.json': SearchResultsBody,
  'https://traegergrills.com/data/contentTypes/shopBy.json': ShopBy,
  'https://traeger.com/v2/sideBySide.json': SideBySide,
  'https://traegergrills.com/data/contentTypes/sideModalInstruction.json': SideModalInstructions,
  'https://traegergrills.com/data/contentTypes/splitBackground.json': SplitBackground,
  'https://traegergrills.com/data/contentTypes/splitToutContent.json': SplitToutContent,
  'https://traegergrills.com/data/contentTypes/toutContentWithMarkdown.json':
    ToutContentWithMarkdown,
  'https://traegergrills.com/data/contentTypes/titledSplitToutContent.json': TitledSplitToutContent,
  'https://traegergrills.com/data/contentTypes/spotlightCarousel.json': SpotlightCarousel,
  'https://traegergrills.com/data/contentTypes/story.json': Story,
  'https://traegergrills.com/data/contentTypes/threeColumnContent.json': ThreeColumnContent,
  'https://traegergrills.com/data/contentTypes/twoThirdsSplitText.json': TwoThirdsText,
  'https://traegergrills.com/data/contentTypes/faqAccordion.json': FaqAccordion,
  'https://traegergrills.com/data/slot/traegerTVCategoryBody.json': TraegerTVCategoryBody,
  'https://traegergrills.com/data/contentTypes/generalTwoThirdSplitContent.json':
    TwoThirdsGeneralContent,
  'https://traegergrills.com/data/contentTypes/woodPelletFlavors.json': WoodPelletFlavors,
  'https://traegergrills.com/data/contentTypes/videoFadeHero.json': VideoFadeHero,
  'https://traeger.com/v2/imageSection.json': ImageSection,
  'https://traeger.com/v2/chipBar.json': ChipBar,
  'https://traeger.com/v2/countdownComponent.json': CountdownComponent,
  'https://traegergrills.com/data/slot/404body.json': ErrorBody,
};

// FetchAsync functions
const cascadingCardsFetch = () => import('@functions/fetch-async/cascading-cards');
const categoryGridFetch = () => import('@functions/fetch-async/category-grid');
const grillFeatureComparisonFetch = () => import('@functions/fetch-async/grill-feature-comparison');
const learnCategoryBodyFetch = () => import('@functions/fetch-async/learn-category-body');
const productGridFetch = () => import('@functions/fetch-async/product-grid');
const recipeCategoryBodyFetch = () => import('@functions/fetch-async/recipe-category-body');
const referenceCarouselFetch = () => import('@functions/fetch-async/reference-carousel');
const relatedProductGridFetch = () => import('@functions/fetch-async/related-product-grid');
const shopByGrillFetch = () => import('@functions/fetch-async/shop-by-grill');
const traegerTvCategoryBodyFetch = () => import('@functions/fetch-async/traeger-tv-category-body');
const productComparisonFetch = () => import('@functions/fetch-async/productComparisonFetch');

export const appFetchAsyncFuncs = {
  'https://traegergrills.com/data/slot/recipeCategoryBody.json': recipeCategoryBodyFetch,
  'https://traegergrills.com/data/slot/learnCategoryBody.json': learnCategoryBodyFetch,
  'https://traeger.com/v2/view/productComparison.json': productComparisonFetch,
  'https://traegergrills.com/data/contentTypes/generalReferenceCarousel.json':
    referenceCarouselFetch,
  'https://traegergrills.com/data/contentTypes/recommendedAccessories.json': referenceCarouselFetch,
  'https://traegergrills.com/data/contentTypes/shopByGrill.json': shopByGrillFetch,
  'https://traegergrills.com/data/slot/traegerTVCategoryBody.json': traegerTvCategoryBodyFetch,
  'https://traegergrills.com/data/contentTypes/categoryGrid.json': categoryGridFetch,
  'https://traegergrills.com/data/contentTypes/cascadingCards.json': cascadingCardsFetch,
  'https://traegergrills.com/data/contentTypes/relatedProductGrid.json': relatedProductGridFetch,
  'https://traegergrills.com/data/contentTypes/grillFeatureComparison.json':
    grillFeatureComparisonFetch,
  'https://traegergrills.com/data/contentTypes/productGrid.json': productGridFetch,
  'https://traegergrills.com/data/contentTypes/recommendedProducts.json': referenceCarouselFetch,
};
